import { render, staticRenderFns } from "./TransferRouteDriver.vue?vue&type=template&id=144a6f57"
import script from "./TransferRouteDriver.vue?vue&type=script&lang=js"
export * from "./TransferRouteDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports